// store/userSlice.js
import { createSlice } from "@reduxjs/toolkit";

const accountTypeSlice = createSlice({
  name: "account",
  initialState: {
    accountTypeId: 1,
    applicantCountry: 1,
    applicationType: 1,
  },
  reducers: {
    setAccountTypeId: (state, action) => {
      state.accountTypeId = action.payload;
    },
    clearAccountTypeId: (state) => {
      state.accountTypeId = 1;
    },
    setApplicantCountry: (state, action) => {
      state.applicantCountry = action.payload;
    },
    clearApplicantCountry: (state) => {
      state.applicantCountry = 1;
    },
        setApplicationType: (state, action) => {
      state.applicationType = action.payload;
    },
    clearApplicationType: (state) => {
      state.applicationType = 1;
    },
  },
});

export const {
  setAccountTypeId,
  clearAccountTypeId,
  setApplicantCountry,
  clearApplicantCountry,
  setApplicationType,
  clearApplicationType
} = accountTypeSlice.actions;
export default accountTypeSlice.reducer;
